import { render, staticRenderFns } from "./DetailMetricExcel.vue?vue&type=template&id=66f90b6e"
import script from "./DetailMetricExcel.vue?vue&type=script&lang=js"
export * from "./DetailMetricExcel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports